import {
  CheckoutCardConfig,
  CheckoutCardProvider,
} from '@checkout/util-models';

export const paysafeConfigFactory = (
  checkoutCardConfig?: CheckoutCardConfig
): CheckoutCardConfig | undefined =>
  checkoutCardConfig?.provider === CheckoutCardProvider.Paysafe
    ? checkoutCardConfig
    : undefined;
